import { MessageBoxType } from '@ui5/webcomponents-react';
import { ConfirmationDialog } from 'components/shared/ConfirmationDialog';
import { useCompleteAnsweredQueryMutation } from 'generated/graphql';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { UserDialogProps } from '../../CompleteQuery';

export const CompleteQueryDialog: React.FC<UserDialogProps> = (props) => {
  const { t } = useTranslation();
  const { id, open, closeConfirmationDialog, setResultMessage } = props;
  const [, completeAnsweredQueryMutation] = useCompleteAnsweredQueryMutation();

  const completeQuery = async () => {
    const result = await completeAnsweredQueryMutation({ id });

    if (result.error) {
      setResultMessage({
        isSuccess: false,
        message: t('complete-query-error-message')
      });
    } else {
      setResultMessage({
        isSuccess: true,
        message: t('complete-query-success-message')
      });
    }
  };

  return (
    <ConfirmationDialog
      open={open}
      type={MessageBoxType.Confirm}
      onClose={closeConfirmationDialog}
      onConfirm={completeQuery}
      data-testid="complete-query-confirmation-dialog"
    >
      {t('complete-query-answered-confirmation')}
    </ConfirmationDialog>
  );
};
